var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"back-icon",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("@/assets/images/other/m/back.png")}})]),_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.title.replace(/\<\w+ \/\>/g, "")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }